import UpdateProfileForm from './UpdateProfileForm';

export default UpdateProfileForm;
